// extracted by mini-css-extract-plugin
export const container = "contact-us-module--container--3HyYz";
export const content = "contact-us-module--content--1TTfF";
export const donateImage = "contact-us-module--donateImage--2h3zH";
export const howToReachUs = "contact-us-module--howToReachUs--DxVUi";